import { TransactionsMobileColumn } from 'BreetComponents';
import {
	formatDateTime,
	isConversions,
	isEdits,
	isWithdrawals,
	type ITransactionHistory,
	type TransactionHistoryType,
} from 'BreetHelpers';

import {
	currencyDisplayNames,
	getTransactionEditsType,
	type ITableColumnTransactionDetails,
} from '../../WalletTransactions.helpers';

const TableColumnTransactionDetails = ({ row, onColumnClick }: ITableColumnTransactionDetails) => {
	const getAccountDetails = (transaction: ITransactionHistory<TransactionHistoryType>): string => {
		if (isWithdrawals(transaction)) {
			const { meta } = transaction.doc;
			return meta.type === 'nuban' ? `${meta.accountNumber} ${meta.bankName}` : 'Crypto Withdrawals';
		}
		if (isEdits(transaction)) {
			return getTransactionEditsType(transaction);
		}
		if (isConversions(transaction)) {
			const currencyKey = transaction.doc.to?.toUpperCase() ?? '';
			const currencyName = currencyDisplayNames[currencyKey] ?? '...';
			return `${currencyName} Wallet`;
		}
		return '...';
	};

	const accountDetails = getAccountDetails(row);

	return (
		<TransactionsMobileColumn.Left
			value={accountDetails}
			date={formatDateTime(row.updatedAt)}
			onClick={onColumnClick}
		/>
	);
};

export default TableColumnTransactionDetails;
